export default __webpack_public_path__ + "static/media/down-icon.bdd7900d.svg";